import React from 'react';
import { Check, X } from 'lucide-react';
import { Reveal } from './ui/Reveal';
const forYou = ['Sientes que estás en una transición.', 'Sabes que tienes potencial, pero algo te frena.', 'Quieres recuperar seguridad y confianza.', 'Estás cansada de repetir determinados patrones.', 'Necesitas claridad sobre tu siguiente paso.', 'Quieres comenzar un proceso de transformación personal.', 'Estás dispuesta a mirarte con honestidad.', 'Estás dispuesta a tomar acción sobre aquello que descubras.'];
const notForYou = ['Buscas una fórmula mágica.', 'Esperas que alguien cambie tu vida por ti.', 'No estás dispuesta a observar tus propios patrones.', 'Quieres resultados sin compromiso personal.'];
export function ForWhomSection() {
  return <section className="bg-champagne px-6 py-20 sm:py-28" data-id="element-101" data-mp="t7pictv8tteh">
      <div className="mx-auto max-w-5xl" data-id="element-102" data-mp="38vh7puwydo5s">
        <Reveal data-id="element-103" data-mp="3dw3wxh1pmpkt">
          <h2 className="text-center font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-104" data-mp="3dwn2dya6blhy">
            La Herradura Dorada{' '}
            <em className="not-italic text-gold-dark" data-id="element-105" data-mp="34sarw44s14d9">es para ti si…</em>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.35fr_1fr] lg:gap-8" data-id="element-106" data-mp="2zusi6bixql47">
          <Reveal delay={0.08} data-id="element-107" data-mp="3dtif9r5r8ksk">
            <div className="h-full rounded-[1.5rem] border border-gold/35 bg-ivory p-8 shadow-soft sm:p-10" data-id="element-108" data-mp="3dqcn231tx2sm">
              <ul className="space-y-4" data-id="element-109" data-mp="3nqwszj0amvh6">
                {forYou.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-110" data-mp="3noshog02eu6v">
                    <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-gold/15" aria-hidden="true" data-id="element-111" data-mp="3irafr9kgtf8d">
                      <Check className="h-3.5 w-3.5 text-gold-dark" strokeWidth={2.5} data-id="element-112" data-mp="3siet64uhss13" />
                    </span>
                    <span className="text-[16.5px] leading-relaxed text-ink-soft sm:text-[18px]" data-id="element-113" data-mp="5e8bmem7v7io">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.16} data-id="element-114" data-mp="385k123ujpsv8">
            <div className="h-full rounded-[1.5rem] border border-ink/10 bg-cream/60 p-8 sm:p-10" data-id="element-115" data-mp="384iofuxvsybe">
              <h3 className="text-[10px] font-semibold uppercase tracking-[0.24em] text-ink-muted" data-id="element-116" data-mp="3cxbsshpfu4my">
                No es para ti si…
              </h3>
              <ul className="mt-6 space-y-4" data-id="element-117" data-mp="3hxpor1drlo4m">
                {notForYou.map(item => <li key={item} className="flex items-start gap-3.5" data-id="element-118" data-mp="3mwkgistpmn0v">
                    <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-ink/8" aria-hidden="true" data-id="element-119" data-mp="3qwkxak4a7ab3">
                      <X className="h-3.5 w-3.5 text-ink-muted" strokeWidth={2.5} data-id="element-120" data-mp="1wjv2m0639x2n" />
                    </span>
                    <span className="text-[16.5px] leading-relaxed text-ink-muted sm:text-[18px]" data-id="element-121" data-mp="21j7nwghbaw34">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}